<template>
  <div class="toolTip">
    <ph-info
      class="self-center cursor-pointer w-5 h-auto"
      weight="fill"
      @click="toggleTooltip($event, null)"
      @mouseover="toggleTooltip($event, true)"
      @mouseleave="toggleTooltip($event, false)"
    />
    <div v-show="tooltipToggle" class="bg-light-grey absolute p-3 top-0 left-0 right-0 transform -translate-y-full">
      <span class="text-sm text-black">{{ hint }}</span>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref, defineProps } from 'vue'
import { PhInfo } from '@dnlsndr/vue-phosphor-icons'

const props = defineProps({
  hint: String,
})

const tooltipToggle = ref(false)
/**
 * toogle the tooltip
 */
const toggleTooltip = (event: MouseEvent | PointerEvent, value: boolean | null): void => {
  if (value && event.type !== 'click') tooltipToggle.value = value
  else tooltipToggle.value = !tooltipToggle.value
}
</script>
